import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { NftProfileImportCollectionListTile } from './NftProfileImportCollectionListTile.tsx';
import { useNftProfileOwner } from '../../../../helpers/useNftProfileOwner.tsx';
import { deriveState } from '../../../../helpers/importCollectionsConfig.ts';

import { type NftProfileImportCollectionList_viewer$key } from './__generated__/NftProfileImportCollectionList_viewer.graphql.ts';

import styles from './styles/NftProfileImportCollectionList.scss';

export const NftProfileImportCollectionList: FC<{
    viewer: NftProfileImportCollectionList_viewer$key;
}> = ({ viewer: viewerRef }) => {
    const { isProfileOwner } = useNftProfileOwner();
    const { tokenImports, publicProfile } = useFragment(
        graphql`
            fragment NftProfileImportCollectionList_viewer on Viewer {
                publicProfile(username: $username) {
                    ...NftProfileImportCollectionListTile_publicProfile
                }
                tokenImports: nftTokenContractImports(
                    username: $username
                    creatorAddress: $walletAddress
                ) {
                    edges {
                        collection: node {
                            serviceId
                            incompleteItems: items(
                                importStatuses: [
                                    NFT_ITEM_IMPORT_STATUS_ERROR
                                    NFT_ITEM_IMPORT_STATUS_PROCESSING
                                ]
                            ) {
                                totalResults
                            }
                            ...importCollectionsConfig_contractImport
                            ...NftProfileImportCollectionListTile_contractImport
                        }
                    }
                }
            }
        `,
        viewerRef
    );

    const collections = [];
    for (const edge of tokenImports?.edges || []) {
        const { allowPublic } = deriveState(edge?.collection);
        if (edge?.collection && (allowPublic || isProfileOwner)) {
            collections.push(edge.collection);
        }
    }

    if (!collections.length) {
        return null;
    }
    return (
        <>
            <h2 className={styles.heading}>Collections</h2>
            <ul className={styles.collections}>
                {collections.map(collection => (
                    <NftProfileImportCollectionListTile
                        key={collection.serviceId}
                        publicProfile={publicProfile}
                        collection={collection}
                    />
                ))}
            </ul>
        </>
    );
};
